import { PromptInput } from "#/promptInput"
import { cn } from "@/utils"
import { StopOutlined } from "@ant-design/icons"
import { Select } from "antd"
import Color from "color"
import { useEffect, useMemo, useState } from "react"

type TextInputProps = {
  value: PromptInput['default']
  onChange: (value: PromptInput['default']) => void
  inputOption: PromptInput
  className?: string
}

const DropdownInput = ({ value, onChange, inputOption, className }: TextInputProps) => {
  const options = inputOption.settings?.dropdown?.options || []
  const [selfValue, setSelfValue] = useState<string | string[] | undefined>()

  useEffect(() => {
    if (inputOption.mode === 'single') {
      setSelfValue((value || []).find(item => item.type === 'dropdown')?.value)
    } else {
      setSelfValue((value || []).filter(item => item.type === 'dropdown').map(item => item.value))
    }
  }, [value])

  const handleChange = (value: string | string[] | undefined) => {
    if (typeof value === 'string') {
      onChange([{ type: 'dropdown', value }])
    } else if (Array.isArray(value)) {
      onChange(value.map(item => ({ type: 'dropdown', value: item })))
    } else {
      onChange(value)
    }
  }

  const handleItemClick = (value: string) => {
    if (selfValue?.includes(value)) {
      handleChange(Array.isArray(selfValue) ? selfValue.filter(item => item !== value) : undefined)
    } else {
      handleChange(Array.isArray(selfValue) ? [...selfValue, value] : [value])
    }
  }


  if (options.length > 5 || inputOption.mode === 'multiple') {
    return <Select
      mode="multiple"
      className={className}
      options={options.map(option => ({
        label: option.label,
        value: option.id
      }))}
      value={selfValue}
      onChange={handleChange}
      allowClear
    />
  }

  return <div className={cn("flex items-center gap-1 flex-wrap", className)}>
    {options.filter(d => d.label).map(option => <button
      key={option.id}
      className={cn("cursor-pointer h-8 px-2 rounded-sm border-1 min-w-8 text-[var(--color-secondary)] hover:border-primary-border-hover",
        selfValue?.includes(option.id) && "bg-[var(--color-bg)]")}
      style={{
        '--color-secondary': option.color || '#000',
        '--color-bg': Color(option.color || '#000').alpha(0.1).toString()
      } as React.CSSProperties}
      onClick={() => handleItemClick(option.id)}>{option.label}</button>)
    }
    <button
      className="cursor-pointer h-8 px-2 rounded-sm hover:bg-fill-2 flex items-center gap-0.5"
      onClick={() => onChange([])}><StopOutlined />清除</button>
  </div>
}

export default DropdownInput